import { Color } from '@persona-id/design-tokens';
import { FC } from 'react';

import { ModalBody, ModalContainer, ModalHeader } from 'dashboard/layouts/ModalLayout';
import { Organization } from 'dashboard/models/organization';
import Button from 'design-system/components/Button';
import Spacer from 'design-system/components/Spacer';
import { HStack } from 'design-system/components/Stack';
import { Heading, Paragraph } from 'design-system/components/Text';

interface ImpersonationResumeModalProps {
  endSession: () => void;
  resumeSession: (() => void) | (() => Promise<void>);
  organization: Organization;
}

const ImpersonationResumeModal: FC<ImpersonationResumeModalProps> = ({
  endSession,
  resumeSession,
  organization,
}) => {
  return (
    <ModalContainer data-test='impersonation-notice-modal'>
      <ModalHeader data-test='impersonation-notice-modal__header' onClose={undefined}>
        Ongoing impersonation session
      </ModalHeader>

      <ModalBody>
        <Paragraph data-test='impersonation-notice-modal__message'>
          Resume current impersonation session? You are currently impersonating:
        </Paragraph>
        <Spacer height={2} />
        <Heading size='md' style={{ color: Color.PrimaryRed }}>
          {organization?.attributes?.name}
        </Heading>

        <Spacer height={4} />

        <HStack equal={true}>
          <Button
            id='impersonation-notice-modal__resume'
            data-test='impersonation-notice-modal__resume'
            variant='basic'
            onClick={resumeSession}
            style={{ whiteSpace: 'normal' }}
          >
            Impersonate {organization?.attributes?.name}
          </Button>
          <Button
            autoFocus={true}
            id='impersonation-notice-modal__end'
            data-test='impersonation-notice-modal__end'
            variant='primary'
            onClick={endSession}
          >
            End session
          </Button>
        </HStack>
      </ModalBody>
    </ModalContainer>
  );
};

export default ImpersonationResumeModal;
